import PropTypes from "prop-types";

function SellMobile({ app, config }) {
  return <></>;
}

SellMobile.defaultProps = {
  app: null,
  config: {},
};

SellMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SellMobile;
